<template>
<div class="chapter">
<div class="inner_page">
<h1 class="otherbooks" id="fm1">Author’s Note</h1>
<p class="nonindent">Just as <em>2010: Odyssey Two</em> was not a direct sequel to <em>2001: A Space Odyssey</em>, so this book is not a linear sequel to <em>2010</em>. They must all be considered as variations on the same theme, involving many of the same characters and situations, but not necessarily happening in the same universe.</p>
<p class="indent">Developments since 1964, when Stanley Kubrick suggested (five years before men landed on the Moon!) that we should attempt “the proverbial good science-fiction movie,” make total consistency impossible, as the later stories incorporate discoveries and events that had not even taken place when the earlier books were written. <em>2010</em> was made possible by the brilliantly successful 1979 Voyager flybys of Jupiter, and I had not intended to return to that territory until the results of the even more ambitious Galileo Mission were in.</p>
<p class="indent">Galileo would have dropped a probe into the Jovian atmosphere, while spending almost two years visiting all the major satellites. It should have been launched from the Space Shuttle in May 1986, and would have reached its objective by December 1988. So around 1990 I hoped to take advantage of the flood of new information from Jupiter and its moons…</p>
<p class="indent">Alas, the <em>Challenger</em> tragedy eliminated that scenario; Galileo—now sitting in its clean room at the Jet Propulsion Laboratory—must now find another launch vehicle. It will be lucky if it arrives at Jupiter merely seven years behind schedule.</p>
<p class="indent">I have decided not to wait.</p>
<p class="right0">Arthur C. Clarke<br/>Colombo, Sri Lanka<br/>April, 1987</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_fm1_r1.vue?903e9748